import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import InputEmail from './InputEmail';

export default compose(withRouter)(InputEmail);
